export default function Button(theme) {
	return {
		MuiFab: {
			styleOverrides: {
				root: {}
			}
		}
	};
}
